// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topup-page {
    background-color: transparent;
    min-height: 100vh;
    padding: 2rem;
    color: rgba(213, 190, 155, 1);
    position: relative;
    font-family: 'CormorantSC-Regular', serif;
}

/* Back Button */
.topup-back-btn {
    position: fixed;
    top: 2rem;
    right: 2rem;
    left: auto;
    z-index: 100;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(213, 190, 155, 1);
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
}

.topup-back-btn:hover {
    background: rgba(213, 190, 155, 0.2);
    transform: scale(1.05);
}

/* Header Section */
.topup-header {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 4rem;
    margin-bottom: 3rem;
    width: 100%;
}

.topup-title {
    font-size: 3.5rem;
    font-weight: 400;
    color: #D5BE9B;
    /* Override global h1 gradient effect */
    background: none;
    background-clip: unset;
    -webkit-text-fill-color: #D5BE9B;
    margin: 0 0 1rem 0;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.topup-subtitle {
    font-size: 1.1rem;
    color: rgba(213, 190, 155, 0.7);
    margin: 0;
    font-family: 'Urbanist-Regular', sans-serif;
    letter-spacing: 0.02em;
}

/* Tabs */
.topup-tabs {
    display: flex;
    justify-content: flex-end;
    gap: 0.8rem;
    border-bottom: none;
    flex-wrap: nowrap;
    align-items: center;
}

.tab-btn {
    background: transparent;
    color: rgba(213, 190, 155, 0.85);
    font-family: 'CormorantSC-Regular', serif;
    font-size: 0.95rem;
    letter-spacing: 0.2em;
    cursor: pointer;
    padding: 0.65rem 1.6rem;
    transition: all 0.3s ease;
    text-transform: uppercase;
    border: none;
    outline: none;
}

.tab-btn.active {
    background: linear-gradient(180deg, rgba(213, 190, 155, 0.25) 0%, rgba(106, 87, 53, 0.95) 100%);
    border-radius: 999px;
    color: #FFF4D6;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.tab-btn:hover:not(.active) {
    color: #FFF4D6;
}

/* Current Plan Section */
.current-plan-section {
    max-width: 1400px;
    margin: 0 auto 4rem auto;
}

.current-plan-card {
    background: linear-gradient(90deg, rgba(40, 35, 30, 0.95) 0%, rgba(24, 22, 20, 0.95) 100%);
    border: 1px solid rgba(213, 190, 155, 0.35);
    border-radius: 40px;
    padding: 1.5rem 2.5rem;
    position: relative;
    max-width: 100%;
    box-shadow: 0 15px 45px rgba(0, 0, 0, 0.45);
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
}

.current-plan-card-horizontal {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    padding: 1.5rem 2.5rem;
}

.current-plan-left {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    flex-shrink: 0;
}

.current-plan-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    flex: 1 1;
    max-width: 400px;
    margin: 0 auto;
}

.current-plan-card-horizontal .plan-progress-track {
    width: 100%;
    min-width: 300px;
}

/* Balance Progress Bar */
.balance-progress-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.balance-progress-track {
    width: 100%;
    height: 10px;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid rgba(213, 190, 155, 0.3);
}

.balance-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, rgba(213, 190, 155, 0.9) 0%, rgba(255, 215, 100, 0.9) 100%);
    border-radius: 5px;
    transition: width 0.5s ease;
    box-shadow: 0 0 10px rgba(213, 190, 155, 0.5);
}

.balance-progress-labels {
    display: flex;
    justify-content: space-between;
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.7rem;
    color: rgba(213, 190, 155, 0.6);
}

.current-plan-right {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.plan-badge {
    position: absolute;
    top: -10px;
    right: 20px;
    background: #00A3FF;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-family: 'Urbanist-ExtraBold', sans-serif;
    box-shadow: 0 4px 10px rgba(0, 163, 255, 0.3);
}

.current-plan-label {
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 1rem;
    color: rgba(213, 190, 155, 0.8);
    margin: 0 0 0.5rem 0;
    font-weight: 400;
}

.current-plan-name {
    font-family: 'CormorantSC-Regular', serif;
    font-size: 1.5rem;
    color: rgba(213, 190, 155, 1);
    display: flex;
    align-items: center;
    gap: 0.6rem;
    letter-spacing: 0.12em;
}

.plan-icon {
    width: 24px;
    height: 24px;
}

.current-plan-row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.plan-info {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.plan-discount-pill {
    padding: 0.25rem 1rem;
    border-radius: 999px;
    background: rgba(213, 190, 155, 0.3);
    color: rgba(213, 190, 155, 1);
    font-size: 0.85rem;
    font-family: 'Urbanist-Regular', sans-serif;
    letter-spacing: 0.08em;
}

.plan-dcoin {
    font-family: 'Urbanist-ExtraBold', sans-serif;
    font-size: 1.4rem;
    color: #D5BE9B;
    display: flex;
    align-items: baseline;
    gap: 0.35rem;
}

.plan-dcoin span {
    font-size: 0.75rem;
    color: rgba(213, 190, 155, 0.8);
    letter-spacing: 0.2em;
}

.plan-progress-track {
    width: 100%;
    height: 12px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    overflow: hidden;
}

.plan-progress-track .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, rgba(255, 224, 182, 1) 0%, rgba(189, 153, 107, 1) 100%);
    border-radius: 999px;
}

.toggle-switch {
    width: 50px;
    height: 26px;
    background: rgba(213, 190, 155, 0.2);
    border-radius: 13px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.toggle-switch.active {
    background: rgba(213, 190, 155, 0.4);
}

.membership-card.legendary .toggle-switch.active {
    background: rgba(213, 190, 155, 0.6);
}

.toggle-handle {
    width: 20px;
    height: 20px;
    background: rgba(213, 190, 155, 1);
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: all 0.3s ease;
}

.membership-card.legendary .toggle-handle {
    background: rgba(213, 190, 155, 1);
}

.toggle-switch.active .toggle-handle {
    left: 27px;
}

/* Membership Cards */
.membership-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
}

.membership-card {
    border-radius: 24px;
    padding: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    gap: 0;
    overflow: hidden;
    border: 1px solid rgba(213, 190, 155, 0.3);
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

/* Card Top Block - Pricing */
.card-top-block {
    background: linear-gradient(180deg, rgba(60, 50, 35, 0.4) 0%, rgba(40, 30, 20, 0.5) 100%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 24px 24px 0 0;
    padding: 2rem 1.5rem;
    position: relative;
    border-bottom: 1px solid rgba(213, 190, 155, 0.2);
}

.membership-card.legendary .card-top-block {
    background: linear-gradient(180deg, rgba(213, 190, 155, 0.15) 0%, rgba(213, 190, 155, 0.08) 100%);
    border-bottom: 1px solid rgba(213, 190, 155, 0.3);
}

/* Card Bottom Block - Benefits */
.card-bottom-block {
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 0 0 24px 24px;
    padding: 2rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    flex: 1 1;
}

/* Card Variants - Border colors */
.membership-card.basic {
    border-color: rgba(255, 255, 255, 0.15);
}

.membership-card.master {
    border-color: rgba(255, 255, 255, 0.25);
}

.membership-card.grandmaster {
    border-color: rgba(213, 190, 155, 0.4);
}

.membership-card.legendary {
    border-color: rgba(213, 190, 155, 0.6);
    box-shadow: 0 8px 32px rgba(213, 190, 155, 0.2);
}

/* Tier-specific glass colors */
.membership-card.master .card-top-block {
    background: rgba(217, 174, 140, 0.9);
    color: #000;
}

.membership-card.master .card-bottom-block {
    background: rgba(217, 174, 140, 0.15);
}

.membership-card.grandmaster .card-top-block {
    background: rgba(182, 182, 182, 0.9);
    color: #000;
}

.membership-card.grandmaster .card-bottom-block {
    background: rgba(182, 182, 182, 0.15);
}

.membership-card.legendary .card-top-block {
    background: rgba(168, 146, 75, 0.92);
    color: #000;
}

.membership-card.legendary .card-bottom-block {
    background: rgba(168, 146, 75, 0.18);
}

.card-badge {
    position: absolute;
    top: -15px;
    left: 20px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-family: 'Urbanist-ExtraBold', sans-serif;
    z-index: 10;
}

.membership-card.basic .card-badge {
    background: #00A3FF;
    color: white;
}

.membership-card.specialist .card-badge {
    background: #00A3FF;
    color: white;
}

/* Adjust if needed */
.membership-card.master .card-badge {
    background: #00A3FF;
    color: white;
}

.membership-card.grandmaster .card-badge {
    background: #00A3FF;
    color: white;
}

.card-header {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
}

.card-pill {
    border: 1px solid rgba(213, 190, 155, 0.4);
    border-radius: 20px;
    padding: 0.5rem 1.5rem;
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 0.9rem;
    color: #fff;
    background: rgba(0, 0, 0, 0.6);
    display: inline-block;
}

.card-price-container {
    text-align: center;
    margin-top: 1.5rem;
}

.price-row {
    display: flex;
    align-items: baseline;
    justify-content: center;
    margin-bottom: 0.5rem;
}

.price-amount {
    font-family: 'Urbanist-ExtraBold', sans-serif;
    font-size: 3.5rem;
    color: rgba(213, 190, 155, 1);
    line-height: 1;
}

.membership-card.master .price-amount,
.membership-card.basic .price-amount {
    color: #fff;
}

.price-unit {
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.6);
    margin-left: 5px;
}

.annual-price-row {
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 1);
    line-height: 1.6;
    margin-top: 0.5rem;
}

.discount-row {
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 1);
    margin-top: 0.25rem;
}

.card-benefits {
    list-style: none;
    padding: 0;
    margin: 0 0 2rem 0;
    flex: 1 1;
}

.benefit-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.8rem 1rem;
    margin-bottom: 0.8rem;
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 0.85rem;
    color: #fff;
}

.benefit-arrow-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: rgba(213, 190, 155, 1);
    stroke-width: 2.5;
}

.benefit-check-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    margin-left: auto;
    color: rgba(213, 190, 155, 1);
    stroke-width: 2.5;
}

.benefit-item span {
    flex: 1 1;
}

.card-footer {
    margin-top: auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.subscription-toggle-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.75rem;
}

.subscription-type-label {
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 0.9rem;
    color: rgba(213, 190, 155, 1);
}

.subscribe-btn {
    width: 100%;
    padding: 1rem;
    background: linear-gradient(180deg, rgba(60, 50, 35, 0.9) 0%, rgba(40, 30, 20, 0.95) 100%);
    border: 1px solid rgba(213, 190, 155, 0.5);
    border-radius: 30px;
    color: #fff;
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
}

.subscribe-btn:hover:not(.disabled) {
    background: rgba(213, 190, 155, 1);
    color: #000;
}

.subscribe-btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.subscribe-btn.legendary {
    background: rgba(213, 190, 155, 0.3);
    border-color: rgba(213, 190, 155, 0.8);
    color: rgba(213, 190, 155, 1);
}

.subscribe-btn.legendary:hover:not(.disabled) {
    background: rgba(213, 190, 155, 0.6);
    color: #000;
}

/* Responsive Design */
@media (max-width: 1200px) {
    .membership-cards {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .membership-cards {
        grid-template-columns: 1fr;
    }

    .topup-title {
        font-size: 2rem;
    }

    .topup-tabs {
        gap: 1.5rem;
        flex-wrap: wrap;
        justify-content: center;
    }
}

@media (max-width: 900px) {
    .topup-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .topup-tabs {
        margin-top: 1.5rem;
        width: 100%;
        flex-wrap: wrap;
    }
}

/* Token Top-up Styles */
.token-recharge {
    max-width: 1400px;
    margin: 0 auto;
}

.premium-packages-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
}

.premium-package-card {
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 24px;
    border: 1px solid rgba(213, 190, 155, 0.3);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.premium-package-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(213, 190, 155, 0.2);
    border-color: rgba(213, 190, 155, 0.5);
}

.package-top-block {
    background: linear-gradient(180deg, rgba(60, 50, 35, 0.6) 0%, rgba(40, 30, 20, 0.7) 100%);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 24px 24px 0 0;
    padding: 2rem 1.5rem;
    border-bottom: 1px solid rgba(213, 190, 155, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
}

.package-label {
    padding: 0.4rem 1rem;
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(213, 190, 155, 0.4);
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 0.85rem;
    color: rgba(213, 190, 155, 1);
    text-align: center;
}

.package-dcoin-container {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.dcoin-icon {
    width: 48px;
    height: 48px;
    object-fit: contain;
}

.package-dcoin-amount {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-family: 'Urbanist-ExtraBold', sans-serif;
    font-size: 2rem;
    line-height: 1;
    color: rgba(213, 190, 155, 1);
}

.package-dcoin-label {
    font-size: 0.9rem;
    font-family: 'Urbanist-Regular', sans-serif;
    color: rgba(213, 190, 155, 0.8);
    margin-top: 0.25rem;
}

.package-bottom-block {
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 0 0 24px 24px;
    padding: 2rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    flex: 1 1;
}

.package-benefits {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
}

.package-benefit-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 0.85rem;
    color: rgba(213, 190, 155, 1);
}

.benefit-plus {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(213, 190, 155, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    color: rgba(213, 190, 155, 1);
    flex-shrink: 0;
}

.package-benefit-item span:not(.benefit-plus) {
    flex: 1 1;
}

.benefit-check {
    width: 16px;
    height: 16px;
    color: rgba(213, 190, 155, 1);
    flex-shrink: 0;
}

.package-buy-btn {
    width: 100%;
    padding: 1rem;
    background: linear-gradient(180deg, rgba(60, 50, 35, 0.9) 0%, rgba(40, 30, 20, 0.95) 100%);
    border: 1px solid rgba(213, 190, 155, 0.5);
    border-radius: 30px;
    color: rgba(213, 190, 155, 1);
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: auto;
}

.package-buy-btn:hover {
    background: rgba(213, 190, 155, 1);
    color: #000;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(213, 190, 155, 0.3);
}

/* Top-up History Styles */
.recharge-history {
    max-width: 800px;
    margin: 0 auto;
    margin-top: 4rem;
}

.history-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.history-item {
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(213, 190, 155, 0.3);
    border-radius: 16px;
    padding: 1.5rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    transition: all 0.3s ease;
}

.history-item:hover {
    border-color: rgba(213, 190, 155, 0.5);
    background: rgba(0, 0, 0, 0.4);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.history-amount-status {
    font-family: 'CormorantSC-Regular', serif;
    font-size: 1.2rem;
    color: rgba(213, 190, 155, 1);
    letter-spacing: 0.05em;
}

.history-timestamp {
    font-family: 'CormorantSC-Regular', serif;
    font-size: 0.9rem;
    color: rgba(213, 190, 155, 0.7);
    letter-spacing: 0.05em;
}

/* Responsive for token top-up */
@media (max-width: 1200px) {
    .premium-packages-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .premium-packages-grid {
        grid-template-columns: 1fr;
    }

    .current-plan-card-horizontal .plan-progress-track {
        min-width: unset;
        /* Remove fixed min-width to prevent overflow */
        width: 100%;
    }

    .current-plan-card-horizontal {
        flex-direction: column;
        gap: 1.5rem;
        padding: 1.5rem;
        /* Reduce padding */
    }

    .topup-page {
        padding: 1rem;
        /* Reduce overall page padding */
        overflow-x: hidden;
        /* Prevent horizontal scroll */
    }

    .current-plan-center {
        max-width: 100%;
        width: 100%;
    }
}

@media (max-width: 480px) {
    .premium-packages-grid {
        grid-template-columns: 1fr;
    }

    .membership-cards {
        grid-template-columns: 1fr;
    }

    .topup-title {
        font-size: 1.8rem;
        /* Smaller title */
        word-break: break-word;
    }
}`, "",{"version":3,"sources":["webpack://./src/userCenter/topUp.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,eAAe;IACf,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAEhB,sBAAsB;IACtB,gCAAgC;IAChC,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,SAAS;IACT,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA,SAAS;AACT;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;IAChC,yCAAyC;IACzC,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,+FAA+F;IAC/F,oBAAoB;IACpB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,0FAA0F;IAC1F,2CAA2C;IAC3C,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,SAAO;IACP,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,8FAA8F;IAC9F,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,4DAA4D;IAC5D,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,6CAA6C;IAC7C,6CAA6C;AACjD;;AAEA;IACI,2CAA2C;IAC3C,eAAe;IACf,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,oCAAoC;IACpC,6BAA6B;IAC7B,kBAAkB;IAClB,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,6CAA6C;IAC7C,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,0FAA0F;IAC1F,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,MAAM;IACN,gBAAgB;IAChB,0CAA0C;IAC1C,8BAA8B;IAC9B,2BAA2B;IAC3B,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA,6BAA6B;AAC7B;IACI,yFAAyF;IACzF,2BAA2B;IAC3B,mCAAmC;IACnC,4BAA4B;IAC5B,oBAAoB;IACpB,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,iGAAiG;IACjG,iDAAiD;AACrD;;AAEA,iCAAiC;AACjC;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,mCAAmC;IACnC,4BAA4B;IAC5B,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAO;AACX;;AAEA,kCAAkC;AAClC;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA,+BAA+B;AAC/B;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,6CAA6C;IAC7C,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,sBAAsB;IACtB,2CAA2C;IAC3C,iBAAiB;IACjB,WAAW;IACX,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,6CAA6C;IAC7C,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,2CAA2C;IAC3C,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,0FAA0F;IAC1F,0CAA0C;IAC1C,mBAAmB;IACnB,WAAW;IACX,2CAA2C;IAC3C,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA,wBAAwB;AACxB;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,mCAAmC;IACnC,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,sCAAsC;AAC1C;;AAEA;IACI,yFAAyF;IACzF,2BAA2B;IAC3B,mCAAmC;IACnC,4BAA4B;IAC5B,oBAAoB;IACpB,iDAAiD;IACjD,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;IAC9B,0CAA0C;IAC1C,2CAA2C;IAC3C,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,6CAA6C;IAC7C,eAAe;IACf,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,2CAA2C;IAC3C,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,mCAAmC;IACnC,4BAA4B;IAC5B,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,2CAA2C;IAC3C,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,0FAA0F;IAC1F,0CAA0C;IAC1C,mBAAmB;IACnB,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,mCAAmC;IACnC,0CAA0C;IAC1C,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA,gCAAgC;AAChC;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;QAChB,+CAA+C;QAC/C,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,gCAAgC;QAChC,kBAAkB;QAClB,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;IAC1B;AACJ","sourcesContent":[".topup-page {\r\n    background-color: transparent;\r\n    min-height: 100vh;\r\n    padding: 2rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    position: relative;\r\n    font-family: 'CormorantSC-Regular', serif;\r\n}\r\n\r\n/* Back Button */\r\n.topup-back-btn {\r\n    position: fixed;\r\n    top: 2rem;\r\n    right: 2rem;\r\n    left: auto;\r\n    z-index: 100;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 48px;\r\n    height: 48px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: rgba(213, 190, 155, 1);\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    backdrop-filter: blur(10px);\r\n}\r\n\r\n.topup-back-btn:hover {\r\n    background: rgba(213, 190, 155, 0.2);\r\n    transform: scale(1.05);\r\n}\r\n\r\n/* Header Section */\r\n.topup-header {\r\n    display: flex;\r\n    align-items: flex-end;\r\n    justify-content: center;\r\n    gap: 4rem;\r\n    margin-bottom: 3rem;\r\n    width: 100%;\r\n}\r\n\r\n.topup-title {\r\n    font-size: 3.5rem;\r\n    font-weight: 400;\r\n    color: #D5BE9B;\r\n    /* Override global h1 gradient effect */\r\n    background: none;\r\n    -webkit-background-clip: unset;\r\n    background-clip: unset;\r\n    -webkit-text-fill-color: #D5BE9B;\r\n    margin: 0 0 1rem 0;\r\n    letter-spacing: 0.05em;\r\n    text-transform: uppercase;\r\n    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.topup-subtitle {\r\n    font-size: 1.1rem;\r\n    color: rgba(213, 190, 155, 0.7);\r\n    margin: 0;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\n/* Tabs */\r\n.topup-tabs {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 0.8rem;\r\n    border-bottom: none;\r\n    flex-wrap: nowrap;\r\n    align-items: center;\r\n}\r\n\r\n.tab-btn {\r\n    background: transparent;\r\n    color: rgba(213, 190, 155, 0.85);\r\n    font-family: 'CormorantSC-Regular', serif;\r\n    font-size: 0.95rem;\r\n    letter-spacing: 0.2em;\r\n    cursor: pointer;\r\n    padding: 0.65rem 1.6rem;\r\n    transition: all 0.3s ease;\r\n    text-transform: uppercase;\r\n    border: none;\r\n    outline: none;\r\n}\r\n\r\n.tab-btn.active {\r\n    background: linear-gradient(180deg, rgba(213, 190, 155, 0.25) 0%, rgba(106, 87, 53, 0.95) 100%);\r\n    border-radius: 999px;\r\n    color: #FFF4D6;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.tab-btn:hover:not(.active) {\r\n    color: #FFF4D6;\r\n}\r\n\r\n/* Current Plan Section */\r\n.current-plan-section {\r\n    max-width: 1400px;\r\n    margin: 0 auto 4rem auto;\r\n}\r\n\r\n.current-plan-card {\r\n    background: linear-gradient(90deg, rgba(40, 35, 30, 0.95) 0%, rgba(24, 22, 20, 0.95) 100%);\r\n    border: 1px solid rgba(213, 190, 155, 0.35);\r\n    border-radius: 40px;\r\n    padding: 1.5rem 2.5rem;\r\n    position: relative;\r\n    max-width: 100%;\r\n    box-shadow: 0 15px 45px rgba(0, 0, 0, 0.45);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.9rem;\r\n}\r\n\r\n.current-plan-card-horizontal {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 2rem;\r\n    padding: 1.5rem 2.5rem;\r\n}\r\n\r\n.current-plan-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.6rem;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.current-plan-center {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    flex: 1;\r\n    max-width: 400px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.current-plan-card-horizontal .plan-progress-track {\r\n    width: 100%;\r\n    min-width: 300px;\r\n}\r\n\r\n/* Balance Progress Bar */\r\n.balance-progress-container {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.3rem;\r\n}\r\n\r\n.balance-progress-track {\r\n    width: 100%;\r\n    height: 10px;\r\n    background: rgba(0, 0, 0, 0.8);\r\n    border-radius: 5px;\r\n    overflow: hidden;\r\n    border: 1px solid rgba(213, 190, 155, 0.3);\r\n}\r\n\r\n.balance-progress-fill {\r\n    height: 100%;\r\n    background: linear-gradient(90deg, rgba(213, 190, 155, 0.9) 0%, rgba(255, 215, 100, 0.9) 100%);\r\n    border-radius: 5px;\r\n    transition: width 0.5s ease;\r\n    box-shadow: 0 0 10px rgba(213, 190, 155, 0.5);\r\n}\r\n\r\n.balance-progress-labels {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.7rem;\r\n    color: rgba(213, 190, 155, 0.6);\r\n}\r\n\r\n.current-plan-right {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.plan-badge {\r\n    position: absolute;\r\n    top: -10px;\r\n    right: 20px;\r\n    background: #00A3FF;\r\n    color: white;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-weight: bold;\r\n    font-family: 'Urbanist-ExtraBold', sans-serif;\r\n    box-shadow: 0 4px 10px rgba(0, 163, 255, 0.3);\r\n}\r\n\r\n.current-plan-label {\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 1rem;\r\n    color: rgba(213, 190, 155, 0.8);\r\n    margin: 0 0 0.5rem 0;\r\n    font-weight: 400;\r\n}\r\n\r\n.current-plan-name {\r\n    font-family: 'CormorantSC-Regular', serif;\r\n    font-size: 1.5rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.6rem;\r\n    letter-spacing: 0.12em;\r\n}\r\n\r\n.plan-icon {\r\n    width: 24px;\r\n    height: 24px;\r\n}\r\n\r\n.current-plan-row {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 1rem;\r\n}\r\n\r\n.plan-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.4rem;\r\n}\r\n\r\n.plan-discount-pill {\r\n    padding: 0.25rem 1rem;\r\n    border-radius: 999px;\r\n    background: rgba(213, 190, 155, 0.3);\r\n    color: rgba(213, 190, 155, 1);\r\n    font-size: 0.85rem;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    letter-spacing: 0.08em;\r\n}\r\n\r\n.plan-dcoin {\r\n    font-family: 'Urbanist-ExtraBold', sans-serif;\r\n    font-size: 1.4rem;\r\n    color: #D5BE9B;\r\n    display: flex;\r\n    align-items: baseline;\r\n    gap: 0.35rem;\r\n}\r\n\r\n.plan-dcoin span {\r\n    font-size: 0.75rem;\r\n    color: rgba(213, 190, 155, 0.8);\r\n    letter-spacing: 0.2em;\r\n}\r\n\r\n.plan-progress-track {\r\n    width: 100%;\r\n    height: 12px;\r\n    border-radius: 999px;\r\n    background: rgba(255, 255, 255, 0.08);\r\n    overflow: hidden;\r\n}\r\n\r\n.plan-progress-track .progress-fill {\r\n    height: 100%;\r\n    background: linear-gradient(90deg, rgba(255, 224, 182, 1) 0%, rgba(189, 153, 107, 1) 100%);\r\n    border-radius: 999px;\r\n}\r\n\r\n.toggle-switch {\r\n    width: 50px;\r\n    height: 26px;\r\n    background: rgba(213, 190, 155, 0.2);\r\n    border-radius: 13px;\r\n    position: relative;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.toggle-switch.active {\r\n    background: rgba(213, 190, 155, 0.4);\r\n}\r\n\r\n.membership-card.legendary .toggle-switch.active {\r\n    background: rgba(213, 190, 155, 0.6);\r\n}\r\n\r\n.toggle-handle {\r\n    width: 20px;\r\n    height: 20px;\r\n    background: rgba(213, 190, 155, 1);\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    top: 3px;\r\n    left: 3px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.membership-card.legendary .toggle-handle {\r\n    background: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.toggle-switch.active .toggle-handle {\r\n    left: 27px;\r\n}\r\n\r\n/* Membership Cards */\r\n.membership-cards {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    gap: 1.5rem;\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.membership-card {\r\n    border-radius: 24px;\r\n    padding: 0;\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    transition: all 0.3s ease;\r\n    gap: 0;\r\n    overflow: hidden;\r\n    border: 1px solid rgba(213, 190, 155, 0.3);\r\n    background: rgba(0, 0, 0, 0.2);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Card Top Block - Pricing */\r\n.card-top-block {\r\n    background: linear-gradient(180deg, rgba(60, 50, 35, 0.4) 0%, rgba(40, 30, 20, 0.5) 100%);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border-radius: 24px 24px 0 0;\r\n    padding: 2rem 1.5rem;\r\n    position: relative;\r\n    border-bottom: 1px solid rgba(213, 190, 155, 0.2);\r\n}\r\n\r\n.membership-card.legendary .card-top-block {\r\n    background: linear-gradient(180deg, rgba(213, 190, 155, 0.15) 0%, rgba(213, 190, 155, 0.08) 100%);\r\n    border-bottom: 1px solid rgba(213, 190, 155, 0.3);\r\n}\r\n\r\n/* Card Bottom Block - Benefits */\r\n.card-bottom-block {\r\n    background: rgba(0, 0, 0, 0.3);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border-radius: 0 0 24px 24px;\r\n    padding: 2rem 1.5rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.5rem;\r\n    flex: 1;\r\n}\r\n\r\n/* Card Variants - Border colors */\r\n.membership-card.basic {\r\n    border-color: rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n.membership-card.master {\r\n    border-color: rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n.membership-card.grandmaster {\r\n    border-color: rgba(213, 190, 155, 0.4);\r\n}\r\n\r\n.membership-card.legendary {\r\n    border-color: rgba(213, 190, 155, 0.6);\r\n    box-shadow: 0 8px 32px rgba(213, 190, 155, 0.2);\r\n}\r\n\r\n/* Tier-specific glass colors */\r\n.membership-card.master .card-top-block {\r\n    background: rgba(217, 174, 140, 0.9);\r\n    color: #000;\r\n}\r\n\r\n.membership-card.master .card-bottom-block {\r\n    background: rgba(217, 174, 140, 0.15);\r\n}\r\n\r\n.membership-card.grandmaster .card-top-block {\r\n    background: rgba(182, 182, 182, 0.9);\r\n    color: #000;\r\n}\r\n\r\n.membership-card.grandmaster .card-bottom-block {\r\n    background: rgba(182, 182, 182, 0.15);\r\n}\r\n\r\n.membership-card.legendary .card-top-block {\r\n    background: rgba(168, 146, 75, 0.92);\r\n    color: #000;\r\n}\r\n\r\n.membership-card.legendary .card-bottom-block {\r\n    background: rgba(168, 146, 75, 0.18);\r\n}\r\n\r\n.card-badge {\r\n    position: absolute;\r\n    top: -15px;\r\n    left: 20px;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-weight: bold;\r\n    font-family: 'Urbanist-ExtraBold', sans-serif;\r\n    z-index: 10;\r\n}\r\n\r\n.membership-card.basic .card-badge {\r\n    background: #00A3FF;\r\n    color: white;\r\n}\r\n\r\n.membership-card.specialist .card-badge {\r\n    background: #00A3FF;\r\n    color: white;\r\n}\r\n\r\n/* Adjust if needed */\r\n.membership-card.master .card-badge {\r\n    background: #00A3FF;\r\n    color: white;\r\n}\r\n\r\n.membership-card.grandmaster .card-badge {\r\n    background: #00A3FF;\r\n    color: white;\r\n}\r\n\r\n.card-header {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.card-pill {\r\n    border: 1px solid rgba(213, 190, 155, 0.4);\r\n    border-radius: 20px;\r\n    padding: 0.5rem 1.5rem;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 0.9rem;\r\n    color: #fff;\r\n    background: rgba(0, 0, 0, 0.6);\r\n    display: inline-block;\r\n}\r\n\r\n.card-price-container {\r\n    text-align: center;\r\n    margin-top: 1.5rem;\r\n}\r\n\r\n.price-row {\r\n    display: flex;\r\n    align-items: baseline;\r\n    justify-content: center;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.price-amount {\r\n    font-family: 'Urbanist-ExtraBold', sans-serif;\r\n    font-size: 3.5rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    line-height: 1;\r\n}\r\n\r\n.membership-card.master .price-amount,\r\n.membership-card.basic .price-amount {\r\n    color: #fff;\r\n}\r\n\r\n.price-unit {\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 1rem;\r\n    color: rgba(255, 255, 255, 0.6);\r\n    margin-left: 5px;\r\n}\r\n\r\n.annual-price-row {\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 0.9rem;\r\n    color: rgba(255, 255, 255, 1);\r\n    line-height: 1.6;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.discount-row {\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 0.9rem;\r\n    color: rgba(255, 255, 255, 1);\r\n    margin-top: 0.25rem;\r\n}\r\n\r\n.card-benefits {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0 0 2rem 0;\r\n    flex: 1;\r\n}\r\n\r\n.benefit-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.75rem;\r\n    padding: 0.8rem 1rem;\r\n    margin-bottom: 0.8rem;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 0.85rem;\r\n    color: #fff;\r\n}\r\n\r\n.benefit-arrow-icon {\r\n    width: 16px;\r\n    height: 16px;\r\n    flex-shrink: 0;\r\n    color: rgba(213, 190, 155, 1);\r\n    stroke-width: 2.5;\r\n}\r\n\r\n.benefit-check-icon {\r\n    width: 16px;\r\n    height: 16px;\r\n    flex-shrink: 0;\r\n    margin-left: auto;\r\n    color: rgba(213, 190, 155, 1);\r\n    stroke-width: 2.5;\r\n}\r\n\r\n.benefit-item span {\r\n    flex: 1;\r\n}\r\n\r\n.card-footer {\r\n    margin-top: auto;\r\n    text-align: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n}\r\n\r\n.subscription-toggle-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 0.75rem;\r\n}\r\n\r\n.subscription-type-label {\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 0.9rem;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.subscribe-btn {\r\n    width: 100%;\r\n    padding: 1rem;\r\n    background: linear-gradient(180deg, rgba(60, 50, 35, 0.9) 0%, rgba(40, 30, 20, 0.95) 100%);\r\n    border: 1px solid rgba(213, 190, 155, 0.5);\r\n    border-radius: 30px;\r\n    color: #fff;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.subscribe-btn:hover:not(.disabled) {\r\n    background: rgba(213, 190, 155, 1);\r\n    color: #000;\r\n}\r\n\r\n.subscribe-btn.disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.subscribe-btn.legendary {\r\n    background: rgba(213, 190, 155, 0.3);\r\n    border-color: rgba(213, 190, 155, 0.8);\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.subscribe-btn.legendary:hover:not(.disabled) {\r\n    background: rgba(213, 190, 155, 0.6);\r\n    color: #000;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1200px) {\r\n    .membership-cards {\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .membership-cards {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .topup-title {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .topup-tabs {\r\n        gap: 1.5rem;\r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n    .topup-header {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n    }\r\n\r\n    .topup-tabs {\r\n        margin-top: 1.5rem;\r\n        width: 100%;\r\n        flex-wrap: wrap;\r\n    }\r\n}\r\n\r\n/* Token Top-up Styles */\r\n.token-recharge {\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.premium-packages-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    gap: 1.5rem;\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.premium-package-card {\r\n    background: rgba(0, 0, 0, 0.3);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border-radius: 24px;\r\n    border: 1px solid rgba(213, 190, 155, 0.3);\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n    transition: all 0.3s ease;\r\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.premium-package-card:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow: 0 12px 40px rgba(213, 190, 155, 0.2);\r\n    border-color: rgba(213, 190, 155, 0.5);\r\n}\r\n\r\n.package-top-block {\r\n    background: linear-gradient(180deg, rgba(60, 50, 35, 0.6) 0%, rgba(40, 30, 20, 0.7) 100%);\r\n    backdrop-filter: blur(10px);\r\n    -webkit-backdrop-filter: blur(10px);\r\n    border-radius: 24px 24px 0 0;\r\n    padding: 2rem 1.5rem;\r\n    border-bottom: 1px solid rgba(213, 190, 155, 0.2);\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 1.5rem;\r\n}\r\n\r\n.package-label {\r\n    padding: 0.4rem 1rem;\r\n    border-radius: 20px;\r\n    background: rgba(0, 0, 0, 0.6);\r\n    border: 1px solid rgba(213, 190, 155, 0.4);\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 0.85rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    text-align: center;\r\n}\r\n\r\n.package-dcoin-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1rem;\r\n}\r\n\r\n.dcoin-icon {\r\n    width: 48px;\r\n    height: 48px;\r\n    object-fit: contain;\r\n}\r\n\r\n.package-dcoin-amount {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    font-family: 'Urbanist-ExtraBold', sans-serif;\r\n    font-size: 2rem;\r\n    line-height: 1;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.package-dcoin-label {\r\n    font-size: 0.9rem;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    color: rgba(213, 190, 155, 0.8);\r\n    margin-top: 0.25rem;\r\n}\r\n\r\n.package-bottom-block {\r\n    background: rgba(0, 0, 0, 0.2);\r\n    backdrop-filter: blur(10px);\r\n    -webkit-backdrop-filter: blur(10px);\r\n    border-radius: 0 0 24px 24px;\r\n    padding: 2rem 1.5rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.5rem;\r\n    flex: 1;\r\n}\r\n\r\n.package-benefits {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.8rem;\r\n}\r\n\r\n.package-benefit-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 0.85rem;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.benefit-plus {\r\n    width: 20px;\r\n    height: 20px;\r\n    border-radius: 50%;\r\n    background: rgba(213, 190, 155, 0.3);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 0.9rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    flex-shrink: 0;\r\n}\r\n\r\n.package-benefit-item span:not(.benefit-plus) {\r\n    flex: 1;\r\n}\r\n\r\n.benefit-check {\r\n    width: 16px;\r\n    height: 16px;\r\n    color: rgba(213, 190, 155, 1);\r\n    flex-shrink: 0;\r\n}\r\n\r\n.package-buy-btn {\r\n    width: 100%;\r\n    padding: 1rem;\r\n    background: linear-gradient(180deg, rgba(60, 50, 35, 0.9) 0%, rgba(40, 30, 20, 0.95) 100%);\r\n    border: 1px solid rgba(213, 190, 155, 0.5);\r\n    border-radius: 30px;\r\n    color: rgba(213, 190, 155, 1);\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    margin-top: auto;\r\n}\r\n\r\n.package-buy-btn:hover {\r\n    background: rgba(213, 190, 155, 1);\r\n    color: #000;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(213, 190, 155, 0.3);\r\n}\r\n\r\n/* Top-up History Styles */\r\n.recharge-history {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    margin-top: 4rem;\r\n}\r\n\r\n.history-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n}\r\n\r\n.history-item {\r\n    background: rgba(0, 0, 0, 0.3);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border: 1px solid rgba(213, 190, 155, 0.3);\r\n    border-radius: 16px;\r\n    padding: 1.5rem 2rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.history-item:hover {\r\n    border-color: rgba(213, 190, 155, 0.5);\r\n    background: rgba(0, 0, 0, 0.4);\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.history-amount-status {\r\n    font-family: 'CormorantSC-Regular', serif;\r\n    font-size: 1.2rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n.history-timestamp {\r\n    font-family: 'CormorantSC-Regular', serif;\r\n    font-size: 0.9rem;\r\n    color: rgba(213, 190, 155, 0.7);\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n/* Responsive for token top-up */\r\n@media (max-width: 1200px) {\r\n    .premium-packages-grid {\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .premium-packages-grid {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .current-plan-card-horizontal .plan-progress-track {\r\n        min-width: unset;\r\n        /* Remove fixed min-width to prevent overflow */\r\n        width: 100%;\r\n    }\r\n\r\n    .current-plan-card-horizontal {\r\n        flex-direction: column;\r\n        gap: 1.5rem;\r\n        padding: 1.5rem;\r\n        /* Reduce padding */\r\n    }\r\n\r\n    .topup-page {\r\n        padding: 1rem;\r\n        /* Reduce overall page padding */\r\n        overflow-x: hidden;\r\n        /* Prevent horizontal scroll */\r\n    }\r\n\r\n    .current-plan-center {\r\n        max-width: 100%;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .premium-packages-grid {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .membership-cards {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .topup-title {\r\n        font-size: 1.8rem;\r\n        /* Smaller title */\r\n        word-break: break-word;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
